import { storyblokEditable } from "@storyblok/react";
import {
  NODE_LI,
  NODE_PARAGRAPH,
  NODE_UL,
  render,
} from "storyblok-rich-text-react-renderer";
import { sbBlok } from "../types/sb-types";
import clsx from "clsx";

const TextBox = ({ blok }: sbBlok) => {
  const {
    text_box_layout,
    spacing_top,
    spacing_bottom,
    spacing_default,
    text_box_items,
  } = blok;

  return (
    <div
      className={clsx("grid-container text-center", {
        "mb-5 2xl:mb-[30px]": spacing_default,
        "pt-7 lg:pt-14":
          !!spacing_top?.length && spacing_top[0].option === "large",
        "pt-14 lg:pt-[120px]":
          !!spacing_top?.length && spacing_top[0].option === "x_large",
        "pt-[120px] lg:pt-[180px]":
          !!spacing_top?.length && spacing_top[0].option === "xx_large",
        "pb-7 lg:pb-14":
          !!spacing_bottom?.length && spacing_bottom[0].option === "large",
        "pb-14 lg:pb-[120px]":
          !!spacing_bottom?.length && spacing_bottom[0].option === "x_large",
        "pb-[120px] lg:pb-[180px]":
          !!spacing_bottom?.length && spacing_bottom[0].option === "xx_large",
      })}
      {...storyblokEditable(blok)}
    >
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26">
        {text_box_items?.length > 0 && (
          <div
            className={clsx("grid gap-5 2xl:gap-[30px]", {
              "md:grid-cols-2": text_box_layout === "two",
              "md:grid-cols-3": text_box_layout === "three",
              "md:grid-cols-4": text_box_layout === "four",
            })}
          >
            {text_box_items?.map((text_box_item: any) => {
              return (
                <div
                  key={text_box_item.title}
                  className="bg-tm-c-gray-950 p-[30px] rounded-[10px] border border-tm-c-gray-700 text-base"
                >
                  <h2 className="mx-0 mb-2.5 !text-2xl">
                    {text_box_item.title}
                  </h2>
                  {render(text_box_item.content, {
                    nodeResolvers: {
                      [NODE_PARAGRAPH]: (children) => <span>{children}</span>,
                      [NODE_UL]: (children) => (
                        <ul className="ps-5">{children}</ul>
                      ),
                      [NODE_LI]: (children) => {
                        return <li>{children}</li>;
                      },
                    },
                  })}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextBox;
